import React from "react"

export default function Seo({title='', data}) {

	const fullTitle = title==''?'Dropship Beauty - Hair & Beauty Dropshipping for Shopify':`Dropship Beauty - ${title}`;

	const description = data.description?data.description:false;


	return <>

		<link rel="shortcut icon" type="image/png" href="/icon.png"/>
		<title>{fullTitle}</title>
		<meta name="twitter:title" content={fullTitle} />

		{
			description&&<meta property="description" content={description}/>
		}

		{
			data.image&&<>
				<meta property="image" content={data.image}/>
				<meta property="og:image" content={data.image}/>
				<meta property="twitter:image" content={data.image}/>
			</>
		}

		{
			data.type?<meta property="og:type" content={data.type}/>:<meta property="og:type" content="website"/>
			
		}

		{
			data.url&&<>
				<meta name="og:url" content={data.url} />
      			<meta name="twitter:url" content={data.url} />
			</>
		}
	</>
}